import type { ScatterShapeProps } from 'recharts';

import { VarianceCategory } from '@/features/TimeStatsModel';

import { EstimationScatterDot } from './EstimationScatterDot';
import { CATEGORY_COLORS } from './utils';

const INNER_RADIUS = 4;
const GAP = 3;
const STROKE_WIDTH = 2.5;

export function resolveScatterDotColors(props: ScatterShapeProps): {
  fill: string;
  stroke: string;
} {
  const { fill: cellFill, stroke: cellStroke } = props as unknown as {
    fill?: string;
    stroke?: string;
  };
  const category = (props.payload as { category?: VarianceCategory } | undefined)?.category;

  return {
    fill: cellFill || '#1976d2',
    stroke: cellStroke || (category && CATEGORY_COLORS[category]) || 'var(--additional-color)',
  };
}

export function EstimationScatterShape(props: ScatterShapeProps) {
  const { cx, cy } = props;

  if (cx == null || cy == null) {
    return null;
  }

  const { fill, stroke } = resolveScatterDotColors(props);

  return (
    <EstimationScatterDot
      cx={cx}
      cy={cy}
      fill={fill}
      stroke={stroke}
      innerRadius={INNER_RADIUS}
      gap={GAP}
      strokeWidth={STROKE_WIDTH}
    />
  );
}
